import { Form } from 'formik';
import { SectionContainerContent } from '../components';
import { useSectionStyles } from './styles';
import { CheckboxWithLabel } from '@uplift/ui-v2';

export const IdentityVerification: React.VFC = () => {
  const { classes } = useSectionStyles();

  return (
    <SectionContainerContent>
      <Form className={classes.formGroup}>
        <CheckboxWithLabel
          name="identityVerified"
          label="Have you confirmed the identity of the patient?"
          color="secondary"
        />
      </Form>
    </SectionContainerContent>
  );
};
